
export function FETCHING_LISTS (state) {
  state.loadingPosts = true
}

export function setIsLoggedIn (state, data) {
  state.isLoggedIn = data
  console.log('setIsLoggedIn', data, state.isLoggedIn)
}

export function setUser (state, data) {
  state.user = data
}
export function setDefaultStore (state, data) {
  state.defaultStore = data
}
export function setRoleMap (state, data) {
  state.rolemap = data
}
export function setFetching (state, data) {
  state.fetching = data
}
export function setSocketConnected (state, data) {
  state.socketConnected = data
}
export function pushRestOrder (state, data) {
  state.restOrder.push(data)
}
export function setRestOrder (state, data) {
  state.restOrder = data
}
export function spliceRestOrder (state, { index }) {
  state.restOrder.splice(index, 1)
}
export function updateOrder (state, { index, count }) {
  state.restOrder[index].count = typeof count === 'string' ? parseFloat(parseFloat(count).toFixed(1)) : parseFloat(count.toFixed(1))
  // console.log(state.restOrder, index, 'updateOrder', state.restOrder[index].count)
}
export function setRestaurants (state, data) {
  state.restaurantsInfos = data
  state.restaurants = data.map(e => e.name)
}
export function setCountries (state, data) {
  state.countries = data
}
export function setVipName (state, data) {
  state.vipName = Object.assign({}, ...data.map(({ level, zh }) => { return { [level]: zh } }))
  state.vipImg = Object.assign({}, ...data.map(({ level, img }) => { return { [level]: img } }))
}
export function setScanID (state, data) {
  state.scanid = data
}
